import { ContentPageContainer, ContentPageTitle } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as Styled from './styled';
import type { LocationLinksPageProps } from './types';

export * from './types';

export const LocationLinksPage: FC<LocationLinksPageProps> = (props) => {
  const { translate } = useTranslation();
  const { sections, proType } = props;

  const title = translate(`links.${proType.toLowerCase()}.list.title`);

  return (
    <ContentPageContainer>
      <ContentPageTitle>{title}</ContentPageTitle>
      {sections.map((section, key) => (
        <Styled.Section key={key}>
          <Styled.SectionTitle>{section.title}</Styled.SectionTitle>
          <Styled.LinksContainer>
            {section.links.map((link, linkKey) => (
              <Styled.StyledLink key={linkKey} to={link.to}>
                {translate(`links.${proType.toLowerCase()}.list.link`).replace('$city', link.label)}
              </Styled.StyledLink>
            ))}
          </Styled.LinksContainer>
        </Styled.Section>
      ))}
    </ContentPageContainer>
  );
};
